// variable to store the JWT
let jwtToken: string | null = null;

// to update the JWT
let userSessionId: string | null = null; // this is temporary

export const setUserSessionId = (sessionId: string | null) => {
  userSessionId = sessionId;
};

export const setJwtToken = (token: string | null) => {
  jwtToken = token;
};

export const getJwtToken = (): string | null => {
  return jwtToken;
};

export const getUserSessionId = (): string | null => {
  return userSessionId;
};

export const getSecurityConfig = (baseUrl: string): unknown => {
  return {
    baseUrl,
    baseApiParams: {
      secure: true,
    },
    securityWorker: () => {
      return {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'x-user-session-id': `${userSessionId}`,
          // temporary workaround: in development, we need to manually provide
          // headers that are typically injected by the API gateway
          ...(true && {
            'x-user-id': 'c2ea202c-750b-4e4a-9b29-48e9b13c672f',
            'x-user-roles': 'admin',
            'x-user-name': 'Alex User',
            'x-user-email': 'alex@jazzx.ai',
          }),
        },
      };
    },
  };
};
